<div class="w-full reative">
  <div class="w-full h-[256px] bg-[#FFE9A2] relative p-2 ">
    <!------------------------------------------ Back ------------------------------------>
    <div class="w-[40px] h-[37px] bg-white shadow-lg rounded-full flex justify-center items-center"
      style="box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25)" (click)="goBack()">
      <img src="icons/arrow_back_black.svg" alt="back" class="w-[30px] h-[30px]" />
    </div>
    <!------------------------------------------ Balance ------------------------------------>
    <div class="w-full px-10  animation-slide-up ">
      <div class="w-full h-[157px] bg-white rounded-[9px] mt-5 flex justify-start items-center relative z-[0]">
        <div class="absolute left-0 top-0 w-full h-full z-[1]" (click)="goToTarnsition()"></div>
        <div class="h-[55px] flex justify-center items-center">
          <div class="w-[48px] h-[46px] bg-[#D9D9D9] rounded-full flex justify-center items-center ml-10">
            <img src="icons/Payment/wallet-payment.png" alt="credit-card" class="w-[36px] h-[36px]" />
          </div>
        </div>
        <div class="h-[55px] pl-4 flex items-center">
          <div class="h-full flex flex-col justify-center items-start">
            <p class="font-semibold text-[16px] text-[#5E5D5D]">
              {{ currentLang === "TH" ? "ยอดเงินคงเหลือ" : "Balance" }}
            </p>
            <p class="font-semibold text-[18px]">
              {{ this.topUpAccount?.amount | number : "1.2-2" }} THB
            </p>
          </div>
        </div>
        <div
          class="absolute right-2 top-2 w-[54px] h-[19px] px-9 z-[10] bg-[#EEEEEE] rounded-full flex justify-center items-center">
          <label class="text-[14px] text-[#71BC5E]">{{
            currentLang === "TH" ? "บัญชี" : "Account"
            }}</label>
        </div>
        <div class="absolute left-2 top-2 w-[54px] h-[19px] z-[10] ml-7 rounded-full flex justify-center items-center">
          <label class="text-[14px] text-[#71BC5E]"> {{ this.topUpAccount?.accountNumber }}
          </label>
        </div>


        <!----------------------------------- Reload -------------------------------->
        <div class="absolute bottom-4 right-5 w-4 h-4 z-[2]" (click)="getTopUpAccount()">
          <img src="/icons/Payment/reload.png" alt="reload" class="w-full h-full" />
        </div>
      </div>
    </div>
  </div>
  <!---------------------------------------- หมวดหมู่ ------------------------------------>
  <div class="flex items-center justify-center space-x-3 mb-2 border-b animation-slide-up delay-200">
    <div class="flex justify-center items-center w-full cursor-pointer p-3 border-r border-gray-100">
      <p class="text-[16px] font-semibold text-gray-700">
        {{ currentLang === "TH" ? "เติมเงิน" : "Top Up" }}
      </p>
    </div>
    <!----------------------------------- History -------------------------------->
    <div class="flex justify-center items-center w-full p-3 cursor-pointer" (click)="goToTarnsition()">
      <p class="text-[16px] text-gray-400">{{ currentLang === "TH" ? "ประวัติการโอนเงิน" : "Transfer History" }}</p>
    </div>
  </div>
  <div class="w-full bg-white px-10 pt-5 pb-[25px] animation-slide-up delay-200">
    <!---------------------------------------- ชื่อ - นามสกุล ------------------------------------>
    <div class="w-full h-[63px]">
      <div class="flex items-center justify-start">
        <img src="icons/Payment/person-payment.png" alt="credit-card" class="w-[26px] h-[26px]" />
        <div class="ml-2 h-[22px]">
          <p>
            {{ currentLang === "TH" ? "ชื่อ-นามสกุล" : "Fristname Lastname" }}
          </p>
        </div>
      </div>
      <div class="ml-1">
        <p class="text-[#7E7E7E] mt-2 w-full rounded-lg">
          {{ this.topUpAccount?.accountName }}
          <!-- {{
            currentLang === "TH" ? "นาย ชื่อ นามสกุล" : "Mr. fristname lastname"
          }} -->
        </p>
        <div class="w-full h-[1px] bg-[#D9D9D9] my-1"></div>
      </div>
    </div>
    <!---------------------------------------- บัญชีธนาคาร ------------------------------------>
    <div class="w-full h-[122px] mt-5">
      <div class="flex items-center justify-start">
        <img src="icons/Payment/building-payment.png" alt="credit-card" class="w-[26px] h-[26px]" />
        <div class="ml-2 h-[22px]">
          <p>
            {{
            currentLang === "TH" ? "ช่องทางการชำระเงิน" : "Payment Options"
            }}
          </p>
        </div>
      </div>
      <div class="w-full h-[208px] grid grid-cols-4 gap-2 mt-4 p-1 overflow-y-auto">
        <!-- <div class="w-full h-[64px] rounded-[10px] flex justify-center items-center" style="box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);"
                    [ngClass]="{
                        'bg-white' : paymentSelect !== 1,
                        'bg-yellow-400 bg-opacity-50 border border-white' : paymentSelect === 1
                    }"
                    (click)="paymentSelect = 1"
                >
                    <img src="icons/Payment/true-logo.png" alt="true" class="w-[38px] h-[38px] object-cover" />
                </div> -->
        <div
          class="w-full h-[64px] rounded-[10px] flex justify-center items-center relative opacity-50 cursor-not-allowed"
          style="
            box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
            background-color: #d1d5db;
          " [ngClass]="{
            'bg-white': true
          }" (click)="(null)">
          <div class="absolute top-[-5px] left-0 p-2">
            <img
              src="data:image/png;base64,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"
              alt="close-sign">
          </div>
          <img src="icons/Payment/true-logo.png" alt="true" class="w-[38px] h-[38px] object-cover" />
        </div>

        <div class="w-full h-[64px] bg-white rounded-[10px] flex justify-center items-center"
          style="box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25)" [ngClass]="{
            'bg-white': paymentSelect !== 2,
            'bg-yellow-400 bg-opacity-50 border border-white':
              paymentSelect === 2
          }" (click)="paymentSelect = 2">
          <img src="icons/Payment/thaiQR_logo.png" alt="true" class="w-[38px] h-[38px] object-cover rounded-lg" />
        </div>
      </div>
    </div>
    <div class="w-full h-[1px] bg-[#D9D9D9] my-4"></div>
    <!---------------------------------------- จำนวนเงิน ------------------------------------>
    <div class="w-full h-auto">
      <p class="text-[18px]">
        {{ currentLang === "TH" ? "จํานวนเงิน" : "Amount" }}
      </p>
      <div class="relative">
        <label class="absolute top-1.5 right-2 text-gray-400">{{ currentLang === "TH" ? "บาท" : "Baht" }}</label>
        <app-input [placeholder]="currentLang === 'TH' ? 'กรุณากรอกจำนวนเงิน' : 'Please enter the amount'"
          [valueIn]="total" [validateType]="'number'" [validateName]="'total'" [validateIn]="validateNumber"
          (valueOut)="total = $event" (validateOut)="validateNumber = { where: $event.where, result: $event.result }">
        </app-input>
      </div>
      <p class="w-full text-[12px] text-[#7E7E7E] mt-3">{{
        currentLang === "TH" ? "*ขั้นต่ำไม่เกิน 10 บาท และสูงสุดไม่เกิน 1,000 บาท" : "*You can top up from 10 Baht and
        can top up to 1,000 Baht"
        }}</p>
      <!-- ปุ่มจำนวนเงิน -->
      <!-- <div
        class="w-full h-auto flex items-center space-x-3 overflow-x-auto scrollbar-hide py-3 px-1"
      >
        <div
          *ngFor="let amount of [50,100,200,250,300,400,500,1000]"
          class="flex-shrink-0 w-[90px] h-[36px] rounded-full flex justify-center items-center border cursor-pointer transition-all duration-200"
          [ngClass]="{
            'bg-white text-gray-700': total !== amount,
            'bg-yellow-700 bg-opacity-50 border-white text-white scale-105':
              total === amount
          }"
          (click)="total = amount"
        >
          <label class="text-[16px]">{{ amount | number }}</label>
        </div>
      </div> -->
      <div class="grid grid-cols-3 gap-4 w-full py-4">
        <div *ngFor="let amount of [60,100,200,250,300,400,500,1000]"
          class="flex-shrink-0 w-full h-[36px] rounded-full flex justify-center items-center border cursor-pointer transition-all duration-400"
          [ngClass]="{
            'bg-white text-gray-700': total !== amount,
            'bg-yellow-700 bg-opacity-50 border-white text-white scale-105':
              total === amount
          }" (click)="handleAmountClicked(amount)">
          <label class="text-[16px]">{{ amount | number }}</label>
        </div>
        <div
          class="flex-shrink-0 w-full h-[36px] rounded-full flex justify-center items-center border cursor-pointer transition-all duration-400"
          (click)="changeToFixedAmount()" [ngClass]="{
            'bg-white text-gray-700': isFixedAmount === false,
            'bg-yellow-700 bg-opacity-50 border-white text-white scale-105':
              isFixedAmount
          }">
          <label class="text-[16px] text-gray-700">{{ currentLang == "TH" ? "กำหนด" : "Fixed" }}</label>
        </div>
      </div>
    </div>
    <div class="w-full h-[1px] bg-[#D9D9D9] my-2"></div>
    <!------------------------------------ นโยบายการชำระเงิน -------------------------------------->
    <div class="w-full pb-4 flex items-center">
      <div class="flex items-center space-x-2 cursor-pointer select-none text-[12px]">
        <div
          class="w-8 h-5 flex items-center justify-center rounded border transition-colors my-theme-custom-checkbox-color"
          [ngClass]="
            paymentPolicy
              ? 'my-theme-custom-checkbox-color-active'
              : 'bg-white border-gray-300'
          " (click)="paymentPolicy = !paymentPolicy">
          <svg *ngIf="paymentPolicy" class="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7" />
          </svg>
        </div>

        <p>
          <span class="text-red-400">
            {{
            currentLang === "TH"
            ? "ฉันยินยอม"
            : "Agree"
            }}
          </span>
          <span class="text-gray-500 ">{{
            currentLang === "TH"
            ? "การเติมเงินเพื่อใช้บริการชาร์จรถไฟฟ้าเท่านั้น ไม่สามารถขอคืนเงินได้ภายหลัง"
            : "Payment Policy"
            }}</span>
        </p>
      </div>

      <!-- <div>
        <span class="text-red-400">
          {{
            currentLang === "TH"
              ? "*คำเตือน"
              : "*Warning"
          }}
        </span>
        <span class="text-[14px] text-gray-400">
          {{ currentLang === "TH" 
            ? "การเติมเงินเพื่อใช้บริการชาร์จรถไฟฟ้าเท่านั้น ไม่สามารถขอคืนเงินได้ภายหลัง" 
            : "Payment Policy" 
          }}
        </span>
      </div> -->
    </div>
    <!---------------------------------------- ปุ่มชำระเงิน ------------------------------------>
    <button [disabled]="!paymentPolicy" class="w-full h-[45px] rounded-[10px]  text-xl"
      (click)="paymentPolicy ? payClick() : null" [ngClass]="{
        'bg-[#F5CA22] text-yellow-800': !validateNumber.result && paymentPolicy,
        'bg-gray-400 text-white cursor-not-allowed': validateNumber.result || !paymentPolicy
      }" [disabled]="validateNumber.result">
      {{ currentLang === "TH" ? "ชำระเงิน" : "Payment" }}
    </button>
  </div>
</div>

<!---------------------------------------- Loading ------------------------------------>
<app-pss-loading *ngIf="isLoading"></app-pss-loading>
<app-toast-warn *ngIf="isWarning" [isButton]="false" [timeIn]="3000" (close)="isWarning = $event"
  [detail]="textWarn"></app-toast-warn>
<app-toast-failed *ngIf="isError" [timeIn]="3000" (close)="isError = $event" [detail]="textError"></app-toast-failed>
<app-toast-success *ngIf="isSuccess" (close)="isSuccess = $event" [timeIn]="3000"
  [detail]="textSuccess"></app-toast-success>

<!---------------------------------------- Modal QR code ------------------------------------>
<div class="fixed inset-0 z-[50] bg-black bg-opacity-50 flex items-center justify-center z-50" *ngIf="isThaiQR">
  <div class="bg-white m-4 rounded-2xl shadow-lg w-full max-w-sm text-center animate-slide-up">
    <div class="custom-bg-head-pay text-white text-2xl rounded flex items-center justify-center p-3">
      <img src="./icons/ThaiQR-removebg.png" class="w-40 h-[50px] object-cover" />
    </div>

    <img [src]="qrImageUrl" alt="Thai QR Code" class="mx-auto w-60 h-60 object-contain mb-4 mt-8" />

    <div class="p-2 px-4">
      <p class="text-lg font-bold text-green-600 mb-2">
        {{ currentLang === "TH" ? "ยอดชำระ" : "Amount" }} {{ total | number }}
        {{ currentLang === "TH" ? "บาท" : "Baht" }}
      </p>

      <!-- <p class="text-sm text-gray-500">
        {{ currentLang === "TH" ? "QR จะหมดอายุใน " : "QR will expire in" }}
        {{ countdown }} {{ currentLang === "TH" ? "วินาที" : "second" }}
      </p> -->

      <div class="mt-4 mb-2 px-2">
        <button class="w-full px-4 py-2 bg-blue-500 text-white rounded hover:bg-red-600" (click)="checkPaymentTopup()">
          {{ currentLang === "TH" ? "ชำระแล้ว" : "Payment completed" }}
        </button>
      </div>

      <div class="mt-2 px-2">
        <button class="w-full px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600" (click)="close()">
          {{ currentLang === "TH" ? "ยกเลิก" : "Cancle" }}
        </button>
      </div>
    </div>
  </div>
</div>

<!---------------------------------------- Modal Notice -------------------------------------->
<app-pss-warn *ngIf="modalNotice" [isButtonConfirm]="true" [language]="currentLang"
  (submit)="submitNoticeEvcharger($event)" (close)="closeNoticeEvcharger($event)" [detail]="currentLang === 'TH'
      ? 'ตอนนี้เติมเงินสามารถใช้ได้กับ EV Charger เท่านั้น!'
      : 'Top-up credits can currently be used for EV chargers only.'">
</app-pss-warn>

<!---------------------------------------- Modal กำหนดราคา ------------------------------------>
<div class="fixed top-0 left-0 right-0 bottom-0 bg-black bg-opacity-50 flex justify-center items-center"
  *ngIf="modalFixedAmount">
  <div class="bg-white rounded-[10px] w-[300px] h-auto py-4 space-y-4">
    <div class="flex flex-col justify-center items-center">
      <p class="text-[18px] font-semibold py-2">
        {{ currentLang === "TH" ? "กำหนดราคา" : "Enter the amount" }}
      </p>
      <input
        class="px-4 py-2 border-b border-[#D9D9D9] rounded-lg focus:outline-none focus:border-[#FFC011] focus:shadow-md"
        [(ngModel)]="figPrice" type="number" placeholder="กรอกราคาตามกำหนด" />
    </div>
    <div class="flex justify-center items-center space-x-2 px-4">
      <button class="w-full h-[45px] rounded-[10px] bg-[#FFE372] text-white text-xl px-2"
        (click)="confirmToFixedAmount()">
        ตงลง
      </button>
      <button class="w-full h-[45px] rounded-[10px] bg-gray-400 text-white text-xl px-2"
        (click)="changeToFixedAmount()">
        ยกเลิก
      </button>
    </div>
  </div>
</div>

<!---------------------------------------- Modal ยืนยัน ------------------------------------>
<div class="fixed top-0 left-0 right-0 bottom-0 bg-black bg-opacity-50 flex justify-center items-center"
  *ngIf="modalConfirmPayment">
  <div class="bg-white rounded-[10px] w-[300px] h-auto py-4 space-y-4">
    <div class="px-4">
      <button class="w-full h-[45px] rounded-[10px] bg-gray-300 text-white text-xl"
        (click)="this.modalConfirmPayment = !this.modalConfirmPayment">
        {{ currentLang === "TH" ? "ยกเลิก" : "Cancel" }}
      </button>
    </div>
  </div>
</div>